import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

import { SettingsService } from '../../shared/settings/settings.service';
import { PagetitleService } from '../../core/pagetitle/pagetitle.service';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss', './header.menu-links.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent implements OnInit {

    sidebarVisible: true;
    sidebarOffcanvasVisible: boolean;
    profile = '/dealers-portal/profile';
    login = '/login';

    constructor(public settings: SettingsService, public pt: PagetitleService, private authService: AuthService) { }

    ngOnInit() {
    }

    toggleSidebarOffcanvasVisible() {
        this.settings.app.sidebar.offcanvasVisible = !this.settings.app.sidebar.offcanvasVisible;
    }

    toggleSidebar(state = null) {
        //  state === true -> open
        //  state === false -> close
        //  state === null -> toggle
        this.settings.app.sidebar.visible = state !== null ? state : !this.settings.app.sidebar.visible;
    }

    logout() {
      this.authService.logout();
    }

    openModalSearch() {

    }

    openModalBar() {

    }

}



// WEBPACK FOOTER //
// /home/alinu/Alin/Work/Workspace/BART-client/src/app/layout/header/header.component.ts